// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2sj2G","question":"styles_question__2-Qyd","inputVisibleButton":"styles_inputVisibleButton__3oOID","note":"styles_note__nf9lM"};